import api from "dao/providers/axios";
import appconfig from "config/appconfig";
import environment from 'lib/environment';

const oAuthPermissionsEndPoint = appconfig.endpoints.oAuthPermissions;
const oAuthClientOwner = appconfig.endpoints.oAuthClientOwner;
const oAuthClientOwnerDelete = appconfig.endpoints.oAuthClientOwnerDelete;
const oAuthClientOwnerAdd = appconfig.endpoints.oAuthClientOwnerAdd;
const oAuthScpesEndPoint =  appconfig.endpoints.oAuthScopes;
const oAuthScopeIsValid = appconfig.endpoints.oauthScopeIsValid;
const portalBaseUrl= { baseURL: environment.get().api.portalURL };

export const daoOAuthPermissionsGet = (clientId) => api.get(oAuthPermissionsEndPoint(clientId));

export const daoOauthScopesGet = () => api.get(oAuthScpesEndPoint);

export const daoOAuthClientOwnerGet = (clientId) => api.get(oAuthClientOwner(clientId), portalBaseUrl);

export const daoOAuthClientOwnerDelete = (clientId, ownerEmail) => api.delete(oAuthClientOwnerDelete(clientId, ownerEmail), portalBaseUrl);

export const daoOAuthClientOwnerAdd = (clientId, ownerEmail) => api.put(oAuthClientOwnerAdd(clientId, ownerEmail), {}, portalBaseUrl);

export const daoOAuthIsScopeValid = (scopeName) => api.get(oAuthScopeIsValid(scopeName), portalBaseUrl);